import { FlvDemuxer, Mp4Remuxer as Remuxer } from 'xgplayer-helper-transmuxers'
import { FetchLoader, Mse } from 'xgplayer-helper-utils'
import { Tracks, RemuxedBufferManager, Buffer as XgBuffer } from 'xgplayer-helper-models'
import { Compat as Compatibility } from 'xgplayer-helper-codec'

class Logger {
  warn () {}
}

export const CORE_EVENT = {
  LOADRETRY: 'retry',
  TTFB: 'ttfb',
  METADATA: 'metadataparsed',
  KEYFRAME: 'isKeyframe',
  SEI: 'SEI_PARSED',
  CHASE_FRAME: 'chaseframe'

}

export default {
  Remuxer,
  FlvDemuxer,
  FetchLoader,
  Tracks,
  RemuxedBufferManager,
  XgBuffer,
  Compatibility,
  Mse,
  Logger
}
